<template>
    <!-- Heading Row -->
    <div class="container" style="margin-top: 50px;">

        <MyLevel></MyLevel>
        <hr/>
        <div class="col-lg-12 ">
            <button type="button" class="btn btn-primary btn-login text-uppercase font-weight-bold" style="border-radius: 20px;"># 카라두잉</button>

            <p class="infoText font-weight-light"> 카라에서 운영하는 모든 봉사활동, 교육, 이벤트에
              대한 정보를 하나의 시스템 안에서 공유하고, 관심 있는 활동에
              효율적으로 참여하도록 지원하기 위한 시스템입니다.
            </p>
            <p class="infoText text-primary">
                <router-link v-for="c in $root.$children[0].category" class="tag"
                        :to="{name : 'activitySearch',
                                         params : { size:'10', page:'0', target:'activityTags', value:c.name, query:`activityTags:${c.name.replace('#','')}` }}">
                    #{{c.name}}
                </router-link>
            </p>
        </div>
      <!-- /.col-md-4 -->
    </div>
    <!-- /.row -->

</template>

<script>
import MyLevel from '@/components/MyLevel.vue'

export default {
    name: 'HelloWorld',
    components: {
        MyLevel,
    },
    props: {
        msg: String
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.infoText{margin-top:20px;}
.tag{margin: 0 10px 0 10px}
</style>
